const listaDeFormularios = (state) => {
    return state.items;
}

const loadingFormularios = (state) => {
    return state.carregando
}

export {
    listaDeFormularios,
    loadingFormularios
}